import React from 'react';
const IconArrowBranch = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M4 4H10L7.71 6.29L13 11.59V20H11V12.41L6.29 7.71L4 10V4ZM16.29 6.29L14 4H20V10L17.71 7.71L14.83 10.59L13.41 9.17L16.29 6.29Z" fill="#666666"/>
</svg>
);
};
export default IconArrowBranch;